import * as _ from 'lodash';
import { Formatter } from 'slickgrid';

const DEFAULTS = {
  separator: ', ',
};

export interface JoinFormatterOptions {
  separator?: string;
}

export function join<T>(opts: JoinFormatterOptions): Formatter<T> {
  const v = { ...DEFAULTS, ...opts };

  return function joinFormatter(row, cell, value, columnDef, data) {
    if (_.isArray(value)) {
      return value.length ? value.join(v.separator) : '';
    }
    return value;
  };
}
